import LoadableWidthInput from './loadable_width_input'
import ReactComponent from 'lib/modulor/react_component'

ReactComponent.register(LoadableWidthInput, 'Modulor.WidthInput')
